import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import { getAllBanks, submitRequest } from "@eres/mortgageQuotationAPI/api";
import { MQBank, MQReference, MQSubmitRequest } from "@eres/mortgageQuotationAPI/entities";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import * as SSO from "@10x/sso";
import { getEmiratesID, getName, getParticipantID } from "@10x/sso";
import { LocaleUtil, StringUtil } from "@eres/core";
import { getVillaName, TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { Lookup } from "@eres/ejari-api/Entity";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { phoneNumber, toMobileX } from "../MyDLD/MyProfile";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { ErrorContainer } from "@eres/forms";
import { isEmailAddress, isEmptyStringOrNull, normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import AddBanks from "@my-dld/components/MortgageQuotation/AddBanks";
import FormRow from "@eres/forms-web/FormRow";
import CurrencyInputField from "@eres/forms-web/CurrencyInputField";
import CountInputField from "@eres/forms-web/CountInputField";
import PickerInput from "@eres/forms-web/PickerInput";
import TextInputField from "@eres/forms-web/TextInputField";
import MobileInputField from "@eres/forms-web/MobileInputField";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import localMobileConverter from "@eres/forms/converters/LocalMobileConverter";
import MQRequestSuccess from "@my-dld/components/MortgageQuotation/MQRequestSuccess";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import { getAppServices } from "@10x/coreapp";

const INCOME_10K: Lookup = {
	Id: 1, ...LVStrings.income_10k,
};

const INCOME_50K: Lookup = {
	Id: 2, ...LVStrings.income_50k,
};

const INCOME_100K: Lookup = {
	Id: 3, ...LVStrings.income_100k,
};

const IncomeRanges = [ INCOME_10K, INCOME_50K, INCOME_100K ];

interface Props extends RoutedViewProps<{ propertyTypeId: string; propertyId: string }> {

}

interface State extends LoadableDataState {
	property: AssetCard;
	banks: MQBank[];
	selBanks: MQBank[];
	amount?: number;
	years?: number;
	income?: Lookup;
	email?: string;
	mobile?: string;
	showBanks?: boolean;
	references?: MQReference[];
	isAgreed?: boolean;
}

class MortgageQuotation extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let property = props.location.state ? props.location.state.property : undefined;
		const { propertyTypeId, propertyId } = props.match.params;
		if ( !property ) {
			let type = Number( propertyTypeId );
			let id = Number( propertyId );
			let assetCards = getAppServices().storeService.getStore().getState().UserData.properties;
			if ( assetCards ) {
				property = assetCards.find( ( p: AssetCard ) => {
					return p.propertyId === id && p.propertyTypeId === type;
				} );
			}
		}
		this.state = {
			property: property,
			banks: [],
			selBanks: [],
			email: SSO.getEmail(),
			mobile: MortgageQuotation.getMobileNumber(),
			errorContainer: {},
			loadState: "loading",
		};
	}

	private static getMobileNumber() {
		let mobile = phoneNumber();
		if ( mobile && !StringUtil.isEmptyStringOrNull( mobile ) ) {
			mobile = toMobileX( mobile );
		}
		return mobile;
	}

	componentDidMount() {
		this.loadBanks();
	}

	render() {
		const { property, banks, selBanks, showBanks, references } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12",
			errorManager: defaultErrorManager,
		};
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ Strings.mortgage_quotation } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.mortgage_quotation } paths={ [ DashboardBCItem ] }/>
			<div className="tender-registration-form">
				<div className="card">
					<div className="card-header d-flex align-items-center justify-content-between">
						<span>{ Strings.mortgage_quotation_details }</span>
						<button className="btn btn-sm" type="button" onClick={ this.onShowBanks }>
							<i className="fa fa-plus ms-2 me-2"/>{ Strings.add_bank }
						</button>
					</div>
					<div className="card-body">
						<small>{ Strings.mandatory_fields_note }</small>
						<RenderBanks
							banks={ selBanks }
							onBankDelete={ this.onBankDelete }/>
						<FormRow { ...filedProps }>
							<CurrencyInputField
								required={ true }
								id={ "amount" }
								label={ Strings.mortgage_amount }
								containerClassName={ "form-group" }/>
							<CountInputField
								id={ "years" }
								label={ Strings.number_of_years }
								minValue={ 1 }
								maxValue={ 99 }
								containerClassName={ "form-group" }/>
							<PickerInput
								required={ true }
								id={ "income" }
								label={ Strings.monthly_income }
								items={ IncomeRanges }
								toIdentifier={ IdExtractor }/>
						</FormRow>
						<div className="mt-3 mb-4">
							<div className="alert alert-info">{ Strings.mortgage_info }</div>
						</div>
						<FormRow { ...filedProps }>
							<TextInputField
								required={ true }
								id={ "email" }
								label={ Strings.email }
								containerClassName={ "form-group" }/>
							<MobileInputField
								required={ true }
								id={ "mobile" }
								label={ Strings.mobile_number }
								valueConverter={ localMobileConverter }
								containerClassName={ "form-group" }/>
						</FormRow>
						<CheckBoxField
							holder={ StateHolder.buildStateHolder( this ) }
							id={ "isAgreed" }
							label={ Strings.mortgage_title_deed }
							labelClassName={ "custom-control-label" }/>
					</div>
				</div>
				<div>
					<button
						className="btn btn_1 btn_style1"
						onClick={ this.onSubmit }>{ Strings.submit }</button>
					<button
						className="btn btn-grey btn_style1 ms-2 me-2"
						onClick={ this.onReset }>{ Strings.reset }</button>
				</div>
				{ showBanks && <AddBanks
					banks={ banks }
					selBanks={ selBanks }
					onDismiss={ this.onBanksAdd }/> }
				{ references && <MQRequestSuccess
					references={ references }
					onDismiss={ () => {
						this.props.history.goBack();
					} }/> }
			</div>
		</PageContent>;
	}

	private onShowBanks = () => {
		this.setState( {
			showBanks: true,
		} );
	};

	private onBanksAdd = ( banks?: MQBank[] ) => {
		const { selBanks } = this.state;
		this.setState( {
			selBanks: banks ? banks : selBanks,
			showBanks: false,
		} );
	};

	private onBankDelete = ( sBank: MQBank ) => {
		const { selBanks } = this.state;
		this.setState( {
			selBanks: selBanks.filter( ( bank: MQBank ) => bank.id !== sBank.id ),
		} );
	};

	private loadBanks() {
		showLoading();
		getAllBanks().then( ( response: MQBank[] ) => {
			hideLoading();
			let banks = response ? response : [];
			banks.sort( ( a: MQBank, b: MQBank ) => {
				const aName = LocaleUtil.getLocalValue( a );
				const bName = LocaleUtil.getLocalValue( b );
				return aName.trim().toLowerCase().localeCompare( bName.trim().toLowerCase() );
			} );
			this.setState( {
				banks: banks,
			} );
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}

	private onReset = () => {
		this.setState( {
			selBanks: [],
			amount: undefined,
			years: undefined,
			income: undefined,
			email: SSO.getEmail(),
			mobile: MortgageQuotation.getMobileNumber(),
			isAgreed: false,
		} );
	};

	private onSubmit = () => {
		if ( this.isValid() ) {
			showLoading();
			const request = this.getRequest();
			submitRequest( request ).then( ( response: MQReference[] ) => {
				hideLoading();
				this.setState( {
					references: response,
				} );
			} ).catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		}
	};

	private isValid() {
		const state = this.state;
		const error: ErrorContainer = {};
		let isValid = checkNonEmpty( state, "amount", error );
		if ( state.amount && Number( state.amount ) === 0 ) {
			isValid = false;
			error.amount = Strings.required;
		}
		if ( state.income == undefined ) {
			isValid = false;
			error.income = Strings.required;
		}
		isValid = checkNonEmpty( state, "email", error ) && isValid;
		if ( state.email && !isEmailAddress( state.email ) ) {
			isValid = false;
			error.email = Strings.invalid_email;
		}
		let mobile = state.mobile ? normaliseMobileNumber( state.mobile ) : "";
		if ( isEmptyStringOrNull( mobile ) || ( mobile && mobile.length !== 12 ) ) {
			error.mobile = Strings.invalid_mobile_number;
			isValid = false;
		}
		if ( state.isAgreed === undefined || !state.isAgreed ) {
			error.isAgreed = Strings.required;
			isValid = false;
		}
		this.setState( {
			errorContainer: error,
		} );
		if ( state.selBanks.length === 0 ) {
			showErrorMessage( Strings.add_bank_error );
			isValid = false;
		}
		return isValid;
	}

	private getRequest(): MQSubmitRequest {
		const { property, selBanks, amount, years, income, email, mobile } = this.state;
		const name = getName();
		const eid = getEmiratesID();
		let buildingNameEn, buildingNameAr, rooms;
		if ( property.propertyTypeId === TabuPropertyType.UNIT ) {
			const buildingName = LocaleUtil.getLocalValue( ( property as any ).buildingName );
			buildingNameEn = LocaleUtil.getLocalValue( buildingName, "en" );
			buildingNameAr = LocaleUtil.getLocalValue( buildingName, "ar" );
			rooms = String( ( property as any ).rooms );
		} else if ( property.propertyTypeId === TabuPropertyType.VILLA ||
			property.propertyTypeId === TabuPropertyType.BUILDING ) {
			const name = getVillaName( property );
			buildingNameEn = name;
			buildingNameAr = name;
			rooms = String( ( property as any ).roomCount );
		}
		return {
			requestor: {
				id: getParticipantID()!,
				nameAr: name ? name.ar! : "",
				nameEn: name ? name.en! : "",
				email: email!,
				mobile: normaliseMobileNumber( mobile! ),
				emiratesId: eid ? eid : "",
			},
			selectedBanks: selBanks,
			property: {
				propertyId: property.tabuPropertyId,
				title: property.title,
				type: property.propertyTypeId,
				areaNameEn: LocaleUtil.getLocalValue( property.area, "en" ),
				areaNameAr: LocaleUtil.getLocalValue( property.area, "ar" ),
				size: String( property.size.squareMeter ),
				rooms: rooms,
				buildingNameEn: buildingNameEn,
				buildingNameAr: buildingNameAr,
			},
			mortgageValue: Number( amount ),
			numberOfYears: String( years ? years : 0 ),
			incomeRange: { en: income?.en, ar: income?.ar },
		};
	}
}

function RenderBanks( props: { banks: MQBank[], onBankDelete: ( bank: MQBank ) => void } ) {
	const { banks, onBankDelete } = props;
	return <div className="row mt-4 mb-md-5 mb-3">
		{ banks.length === 0 && <div className="col-md-6">
			<div className="alert alert-info">{ Strings.no_bank_added }</div>
		</div> }
		{ banks.map( ( bank: MQBank ) => {
			return <div key={ `bank_${ bank.id }` } className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
				<div className="bank-name">
					<div>
						<span>{ Strings.bank_name }</span>
						<span>{ LocaleUtil.getLocalValue( bank ) }</span>
					</div>
					<div>
						<button
							type="button" className="btn btn-sm"
							onClick={ () => onBankDelete( bank ) }>
							<i className="fa fa-trash-alt"/></button>
					</div>
				</div>
			</div>;
		} ) }
	</div>;
}

export default MortgageQuotation;
